import { z } from "zod";

// Base attribute schema (API response)
export const attributeSchema = z.object({
  _id: z.string(),
  name: z.string(),
  description: z.string().optional(),
  icon: z.string().optional(),
  image: z.string().optional(),
  _idRestaurant: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

// Create attribute schema (form validation)
export const createAttributeSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
  icon: z.string().min(1, "Icon is required"),
  image: z.string().optional(),
});

// Update attribute schema (partial)
export const updateAttributeSchema = z.object({
  name: z.string().min(1).optional(),
  description: z.string().optional(),
  icon: z.string().optional(),
  image: z.string().optional(),
});

// Type exports
export type TAttribute = z.infer<typeof attributeSchema>;
export type TCreateAttributeRequest = z.infer<typeof createAttributeSchema>;
export type TUpdateAttributeRequest = z.infer<typeof updateAttributeSchema>;

// Generic API response types
export type TApiResponse<T> = {
  success: boolean;
  code: number;
  msg: string;
  serverTime: string;
  data: {
    rows: T[];
    count: number;
  };
};

export type TApiSingleResponse<T> = {
  success: boolean;
  code: number;
  msg: string;
  serverTime: string;
  data: T;
};
